// import components
import { EndOfEmploymentSettlementsForm } from './EndOfEmploymentSettlementsForm';

// import external libraries
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// import queries
import { queries } from 'RestAPIs/rapini';

// import styles
import { StyledCustomDrawer } from './EndOfEmploymentSettlementsDrawer.styles';

// import types
import { EndOfEmploymentSettlementsDrawerProps } from './EndOfEmploymentSettlementsDrawer.types';

// import utils
import dayjs from 'dayjs';

export const EndOfEmploymentSettlementsDrawer: FC<
  EndOfEmploymentSettlementsDrawerProps
> = ({ open, onClose, selectedRow, showPlusMinusHoursReversed }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'endOfEmploymentSettlement'
  });
  const { employment, endOfEmploymentSettlementDate } = selectedRow || {};
  const employmentId = employment?.id;

  const { data: endOfEmploymentData, isLoading } =
    queries.useGetEndOfEmploymentByEmploymentId(
      employmentId,
      endOfEmploymentSettlementDate || dayjs().format('YYYY-MM-DD')
    );

  return (
    <StyledCustomDrawer
      title={t('settlement')}
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <EndOfEmploymentSettlementsForm
        endOfEmploymentData={endOfEmploymentData}
        isLoading={isLoading}
        onClose={onClose}
        showPlusMinusHoursReversed={showPlusMinusHoursReversed}
      />
    </StyledCustomDrawer>
  );
};
